import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";

const Warning = (props) => {
  const { jobNames, placeHolder } = props;

  return (
    <Box sx={{ fontSize: "0.875rem" }}>
      <>{`The ${placeHolder} has already been selected for the following job(s): (Selecting it for multiple jobs may result in conflict)`}</>
      <ul style={{ paddingTop: "8px" }}>
        {jobNames.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </Box>
  );
};

Warning.propTypes = {
  placeHolder: PropTypes.string.isRequired,
  jobNames: PropTypes.array.isRequired,
};

export default Warning;
